// extracted by mini-css-extract-plugin
export default {"btn_zamknij":"DodajOddanieBtn_btn_zamknij__+lGky"};